import usePrivateAxios from '@/common/api/usePrivateAxios'
import { PrinterMachineData, PrinterMachineResponse } from '@/common/types/printerMachine.type'
import { useQuery } from '@tanstack/react-query'

type UsePrinterMachineProps = {
  id: string
}

export const usePrinterMachine = ({ id }: UsePrinterMachineProps) => {
  const privateAxios = usePrivateAxios()

  return useQuery<PrinterMachineResponse, unknown, PrinterMachineData>({
    queryKey: ['printerMachine', id],
    queryFn: () => {
      return privateAxios.get(`/printer/machines/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
